<div @ShowHide class="ps-4 pe-2 border border-softer rounded">
    <div class="d-flex align-items-center">
        <div class="inline me-2 py-4">
            <div class="icon icon-s icon-default" inlineSVG="assets/icons.svg#user"></div>
        </div>

        <div class="text-default text-uppercase text-odd-xxs font-semi-bold me-auto">{{ user.firstname }} {{ user.surname }}</div>

        <div *ngFor="let achievement of achievementsPreviews" [ngbTooltip]="achievement.name" container="body" class="inline">
            <app-achievement-icon class="icon icon-xxxl" [type]="achievement.type"></app-achievement-icon>
        </div>

        <div *ngIf="achievementsNotPreviewCount !== 0" class="p-2 rounded bg-darker text-xxs font-bold text-line-1 text-white ms-1">
            +{{ achievementsNotPreviewCount }}
        </div>
    </div>
</div>
